export default {
  name: "Nature of H-2B Application",
  prefix: "A",
  pageInfo: {
    text: `<p><b>IMPORTANT:</b>  Employers and authorized preparers must read these instructions carefully before completing the Form ETA-9142B, 
    H-2B Application for Temporary Employment Certification and Appendices A to D.  These instructions contain full explanations of the 
    questions and attestations that make up the Form ETA-9142B and Appendices A to D.<b> In accordance with Federal Regulations, 
    incomplete or obviously inaccurate applications will not be certified by the Department of Labor.  Those items marked with an 
    asterisk (*) are required and must be completed.  Items marked with a section symbol (§) are conditional and must be completed 
    if applicable.</b><br><br>Anyone, who knowingly and/or willfully furnishes any materially false information in the preparation of 
    Form ETA-9142B and any supporting documentation, or aids, abets, or counsels another to do so is committing a federal offense 
    punishable by fine, imprisonment, or both (18 U.S.C. §§ 2, 1001).  Other penalties apply as well to fraud or misuse of this 
    immigration document and to perjury with respect to this form (18 U.S.C. §§ 1546, 1621).`,
    coloring: "grey",
    read_more: true,
    character_limit: 666,
  },
  sections: [
    {
      name: "H-2B Application Visa Cap Estimates",
      fields: [
        {
          isGroup: {
            code: "A.1",
            label: `Of the total number of H-2B workers requested under Section B Item 4 of this application, 
              estimate the number of H-2B workers the employer anticipates will be cap-subject and cap-exempt 
              from the H-2B numerical visa cap.`,
            validate: ["required"],
            tooltip: `Enter estimates of the numbers of H-2B cap-subject workers and H-2B cap-exempt workers 
            the employer anticipates to employ under this application.  The employer should provide estimates 
            based on the information the employer has at the time of the application filing.  These estimates 
            are not binding.  If the employer has no information upon which to base an estimate, 
            enter the total number of H-2B workers sought (i.e. the employer’s entry in Item B.4) 
            as the estimated number of cap-subject H-2B workers in Item A.1a and “0” as the estimated number 
            of cap-exempt H-2B worker in Item A.1b.  For further details on H-2B cap exemptions, please visit 
            the Department of Homeland Security’s U.S. Citizenship and Immigration Services (USCIS) website at www.uscis.gov.
            <br/>
            <br/>
            <b>Important Note</b>:  The Department of Labor (Department) will use the estimates entered into Section A to further 
            inform H-2B filing projections.  The Department will consider the employer's entries in Section A to be estimates 
            only at the time of the Form ETA-9142B filing.  The employer's total H-2B labor request for the job opportunity 
            in the area of intended employment for the period of need must be presented to the Department on a single 
            H-2B application.  The employer must not split applications or submit duplicate applications to respond to this section.  
            The estimated total for Section A must equal the number in Section B Item 4 at the time of filing this application; 
            however, if certification is granted, the number of workers approved may be different.  
            For H-2B certification approvals, the employer must refer to the Final Determination the Department will 
            issue to the employer if certification is granted. `,
            coloring: "none",
            fieldLevelErrors: true,
            showIndividualFieldError: true,
            fields: [
              {
                code: "A.1.a",
                machine_name: "capSubject",
                widget: "text",
                parse: "positiveWholeNumber",
                label: "Cap-Subject",
                validate: [
                  "required",

                  {
                    fieldComparison: "capSubject",
                    message:
                      "This number should be greater than or equal to 1.",
                    needsFieldValues: true,
                    extraData: {
                      operator: ">=",
                      valueOf: 0,
                    },
                  },
                ],
                maxLength: 4,
              },
              {
                code: "A.1.b",
                machine_name: "capExempt",
                widget: "text",
                parse: "positiveWholeNumber",
                label: "Cap-Exempt",
                validate: ["required"],
                maxLength: 4,
              },
            ],
          },
        },
      ],
    },
  ],
};
